var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEraser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1526 2.67219C14.9451 1.87963 16.123 1.77255 16.7835 2.43301L21.567 7.21651C22.2275 7.87697 22.1204 9.05487 21.3278 9.84743L13.2894 17.8858L6.1142 10.7106L14.1526 2.67219Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.05355 11.7712L12.2288 18.9465L10.6752 20.5H22C22.4142 20.5 22.75 20.8358 22.75 21.25C22.75 21.6642 22.4142 22 22 22H8C7.77784 22 7.57825 21.9034 7.44091 21.7499C7.36109 21.6974 7.28594 21.6364 7.21651 21.567L2.43301 16.7835C1.77255 16.123 1.87963 14.9451 2.67219 14.1526L5.05355 11.7712Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEraser);
export default __webpack_public_path__ + "static/media/eraser.86d1ba7592c415d191d30ff634a82af2.svg";
export { ForwardRef as ReactComponent };